import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;
export class ListLoopBlock extends AbstractBlock {
  ARRAY_NAME = 'ARRAY_NAME';
  COUNTER_VAR = 'COUNTER_VAR';

  constructor() {
    super('logic_list-loop_v2', t.to('リストをループ', 'list_loop'));
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setLogicColor(block);
    ShapeSettings.setElementWithSubBlockShape(block);

    // フィールド
    const list = new Blockly.FieldTextInput('list');
    const counter = new Blockly.FieldTextInput('x');

    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(t.to('変数', 'list_loop1'))
      .appendField(counter, this.COUNTER_VAR)
      .appendField(t.to('に、配列', 'list_loop2'))
      .appendField(list, this.ARRAY_NAME)
      .appendField(t.to('からデータを取り出して繰り返す', 'list_loop3'));

    ShapeSettings.addStatementInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const array = CodeSetting.getFieldValue(block, this.ARRAY_NAME);
    const counter = CodeSetting.getFieldValue(block, this.COUNTER_VAR);
    const input = CodeSetting.getSubstatementCode(block);

    const str = `for ( let ${counter} of ${array} ){
			${input}
		}`;
    return str;
  }
}
